export const GENERATE_VEHICLE_AD = {
  generateAd: true,
};
